import { Injectable, Inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {
  private isDarkModeSignal = signal<boolean>(false);
  public isDarkMode = this.isDarkModeSignal.asReadonly();

  constructor(@Inject(DOCUMENT) private document: Document) {
    const htmlElement = this.document.documentElement;
    const isDark = htmlElement.classList.contains('app-dark');
    this.isDarkModeSignal.set(isDark);

    window.addEventListener('storage', (event) => {
      if (event.key === 'app-theme') {
        const isDarkMode = event.newValue === 'dark';
        this.isDarkModeSignal.set(isDarkMode);
      }
    });

    this.observeBodyClassChanges();
  }

  private observeBodyClassChanges(): void {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isDark = this.document.documentElement.classList.contains('app-dark');
          if (this.isDarkModeSignal() !== isDark) {
            this.isDarkModeSignal.set(isDark);
          }
        }
      });
    });

    observer.observe(this.document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  getCurrentDarkMode(): boolean {
    return this.isDarkModeSignal();
  }
}
